import React from 'react'
import { User } from './s'
import Person from 'components/person'
import ContextMenu from 'widgets/context-menu'

const ExcludedUsers = ({ user, actions, pending, salt }) => (
    <User {...(pending ? { className: 'pending' } : null)}>
        <Person
            who={user}
            size={40}
            showPosition />
        <ContextMenu
            salt={salt}
            context={user}
            actions={actions}
            placement="bottom-end" />
    </User>
)

export default ExcludedUsers